import React from "react";
import PropTypes from "prop-types";
import "./audioWavs.scss";

const AudioWave = ({ audioData, flip }) => {
  var path;
  var paths = [];

  for (var i = 0; i < 255; i++) {

    const adjustedLength =
      Math.floor(audioData[i]) - (Math.floor(audioData[i]) % 5);
    const calcLength = !isNaN(adjustedLength) ? (adjustedLength) * -1 : 0;
    path = <path key={i} strokeDasharray="2,2" d={`M ${i},255 l 0,${calcLength}`} />;
    paths.push(path);
  }

  return (
    <div className="audio-wave" style={{transform: flip ? "scaleY(-1)" : ""}}>
      <svg preserveAspectRatio="none" viewBox="0 0 255 255">
        <defs>
          <mask id="mask">
            <g id="maskGroup" />
            {paths}
          </mask>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop
              offset="0%"
              style={{ stopColor: "#16c4ab", stopOpacity: "1" }}
            />
            <stop
              offset="20%"
              style={{ stopColor: "#0eb1a3", stopOpacity: "1" }}
            />
            <stop
              offset="90%"
              style={{ stopColor: "#0e9b8d", stopOpacity: "1" }}
            />
            <stop
              offset="100%"
              style={{ stopColor: "#0d7164", stopOpacity: "1" }}
            />
          </linearGradient>
        </defs>
        <rect
          x="0"
          y="0"
          width="100%"
          height="100%"
          fill="url(#gradient)"
          mask="url(#mask)"
        />
      </svg>
    </div>
  );
};

AudioWave.propTypes = {
    audioData: PropTypes.object.isRequired,
    flip:PropTypes.bool
};
AudioWave.defaultProps = {
    flip: false
};

export default AudioWave;
